import { searchDiagnoses } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { SearchDiagnosesParams } from '@lotushealth/lotushealth_js_sdk/schemas';
import type { DiagnosisSearchResultT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export type { SearchDiagnosesParams };

export async function fetchSearchDiagnoses(
  params: SearchDiagnosesParams,
  signal?: AbortSignal
): Promise<DiagnosisSearchResultT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchDiagnoses(params, config);
  return response.data;
}
